<template>
	<div>
		<div class="layout mx-auto bg-whiteDashboard">
			<!-- Create Page Modal -->
			<transition name="fade" appear>
				<div
					class="modal-overlay w-full"
					v-if="showCreatePage"
					@click="showCreatePage = false"
				></div>
			</transition>
			<transition name="slide" appear>
				<div class="modal text-navyBlue " v-if="showCreatePage">
					<div class="custom-background">
						<div>
							<!-- <h3 class=" text-2xl p-3 ">Lupa Password</h3> -->
							<button
								class="button text-xl float-right mr-2 outline-none focus:outline-none focus:bg-transparent active:bg-transparent"
								@click="showCreatePage = false"
							>
								<fai
									:icon="['far', 'times-circle']"
									class=" text-navyBlue"
									size="lg"
								/>
							</button>
						</div>
						<div class="text-center pt-3 pb-6 ">
							<div class="p-8">
								<div class="mx-8 pt-6 pb-24 ">
									<img
										class="mx-auto"
										src="../../assets/dashboard/home/logo.svg"
										alt="logo"
									/>
									<h1 class=" mb-14 font-bold mt-5 text-3xl">Pilih Halaman</h1>
									<router-link to="/wedding" exact>
										<button
											class="focus:outline-none text-xl my-3 bg-navyBlue text-white py-2 w-full rounded-md font-bold uppercase"
										>
											Wedding
										</button>
									</router-link>
									<button
										class="focus:outline-none text-xl my-3 bg-navyBlue text-white py-2 w-full rounded-md font-bold uppercase"
									>
										Sosmed Bio
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<!-- End Create Page Modal -->
			<div class="flex flex-col h-screen">
				<!-- Header -->
				<header-home />
				<!-- End Header -->
				<main class="mb-auto text-navyBlue">
					<div class="mx-4">
						<div>
							<p class="text-3xl py-4"><b>Hello!</b> Patricia</p>
						</div>
					</div>
					<div class="mx-4">
						<div class="text-center">
							<div class="mx-auto bg-white p-4 rounded-md mb-4">
								<div class="px-11">
									<div class="text-left pt-2 flex">
										<img
											class=" mr-5"
											src="../../assets/dashboard/home/halaman.svg"
											alt="halaman"
											srcset=""
										/>
										<p><b>Halaman</b> yang telah kamu buat</p>
									</div>
									<div>
										<p class=" text-6xl py-3">20</p>
									</div>
									<div>
										<button
											@click="showCreatePage = true"
											class=" font-semibold w-full max-w-xl outline-none focus:outline-none bg-lightPurple text-white py-2 uppercase rounded-md"
											type="submit"
										>
											<b>Buat Halaman Baru</b>
										</button>
									</div>
								</div>
							</div>
							<div class="mx-auto bg-white p-4 rounded-md mb-4">
								<div class="px-11">
									<div class="text-left pt-2 flex">
										<img
											class=" mr-5"
											src="../../assets/dashboard/home/dompet.svg"
											alt="halaman"
											srcset=""
										/>
										<p><b>Komisi</b> yang telah kamu peroleh</p>
									</div>
									<div>
										<div class="flex text-center">
											<p class="flex-1 text-right pt-3 text-lg">
												Rp
											</p>
											<p class="flex-auto text-5xl py-3 text-left">
												888.000
											</p>
										</div>
									</div>
									<div>
										<button
											class=" font-semibold w-full max-w-xl outline-none focus:outline-none bg-lightPurple text-white py-2 uppercase rounded-md"
											type="submit"
										>
											<b>Penarikan</b>
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mx-4 mb-20">
						<div class=" ">
							<div class="w-full bg-navyBlue h-1 rounded-t-xl"></div>
							<table class="w-full h-auto bg-whiteBase ">
								<thead
									class="text-xs text-center bg-navyBlue text-white h-8 font-light "
								>
									<tr class="px-8 text-center">
										<th class="font-light pl-1">No.</th>
										<th class="font-light">Preview</th>
										<th class="font-light">ID</th>
										<th class="font-light">Kategori</th>
										<th class="font-light">Status</th>
										<th class="font-light">Dilihat</th>
										<th class="font-light">Aksi</th>
									</tr>
								</thead>
								<tbody class="text-xs font-light ">
									<tr class=" border-gray-100 border-b-2">
										<td class="pl-1">1</td>
										<td>
											<img
												class="preview  mx-auto"
												src="../../assets/dashboard/home/preview.png"
												alt="link"
											/>
										</td>
										<td class="text-left">#12858</td>
										<td class="text-left">
											Commonry -<br />Landing Page <br /><span
												class="bg-lightYellow text-white px-2 py-0.5 rounded-sm"
												><b>PREMIUM</b></span
											>
										</td>
										<td>Publish</td>
										<td>123000</td>
										<td class="mx-auto">
											<div class="flex flex-col">
												<img
													class="mr-5 w-min py-2 cursor-pointer mx-auto"
													src="../../assets/dashboard/home/link.svg"
													alt="link"
												/>
												<img
													class="mr-5 w-min py-4 cursor-pointer mx-auto"
													src="../../assets/dashboard/home/edit.svg"
													alt="link"
												/>
												<img
													class="mr-5 w-min py-2 cursor-pointer mx-auto"
													src="../../assets/dashboard/home/perpanjang.svg"
													alt="link"
												/>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
							<hr class="border-navyBlue border-b-2" />
							<div class=" pt-4 pb-4 bg-whiteBase rounded-b-sm text-center">
								<div class="mx-auto">
									<div class="pagination">
										<button class="mx-auto" href="#">1</button>
										<button href="#" class="active">2</button>
										<button href="#">3</button>
										<button href="#">4</button>
										<button href="#">5</button>
										<button href="#">6</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				<footer class="static">
					<div class=" mb-0 pb-0 h-full">
						<p class=" bg-navyBlue py-2 text-sm text-whiteBase">
							©2021 joinme.id | All Right Reserved
						</p>
					</div>
				</footer>
				<menus />
			</div>
		</div>
	</div>
</template>

<style scoped>
.custom-background {
	background-image: url("~@/assets/dashboard/home/popup.png");
	background-repeat: no-repeat;
	background-size: 100% auto;
	margin: 10px auto;
}
.preview {
	width: 45px !important;
}
.pagination {
	display: inline-block;
}

.pagination button {
	color: black;
	padding: 6px 12px;
	text-decoration: none;
}

.pagination button.active {
	background-color: #16213e;
	color: white;
	border-radius: 5px;
}

.pagination button:hover:not(.active) {
	background-color: #ddd;
	border-radius: 5px;
}

.modal-overlay {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	height: 100%;
	z-index: 98;
	background-color: rgba(0, 0, 0, 0.3);
}

.modal {
	position: fixed;
	top: 10%;
	bottom: auto;
	left: 50%;
	height: 530px;
	transform: translate(-50%, 0%);
	z-index: 99;
	width: 100%;
	max-width: 380px;
	background-color: #fff;
	border-radius: 10px;
}
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.slide-enter-active {
	transition: transform 0.2s;
}
.slide-leave-active {
	transition: transform 0s;
}

.slide-enter {
	transform: translateX(-50%) translateY(1vw);
}
/* End Modal create page */
</style>

<script>
import Menus from "./items/Menus.vue";
import Header from "./items/Header.vue";
export default {
	name: "home",
	components: {
		menus: Menus,
		"header-home": Header,
	},
	data() {
		return {
			showCreatePage: true,
		};
	},
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400;500;600;700&display=swap");
p,
h1,
h2,
h3,
h4,
h5,
span,
button,
ul,
li {
	font-family: "Karla", sans-serif;
}

.home-table {
	padding-top: 25px;
}
</style>
